module.exports = __webpack_public_path__ + "src/assets/models_low/spectrophotometer/spectrophotometer_apparat.fbx";